module.exports = __webpack_public_path__ + "img/beyChy.12f33709.png";